export default {"src":"/_next/static/media/mda.50565c5b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};